import { render } from "./BaseCarouselNavigation.vue?vue&type=template&id=11b3205d"
import script from "./BaseCarouselNavigation.vue?vue&type=script&lang=js"
export * from "./BaseCarouselNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__